<template>
  <div>
    <div v-if="view == 'description'">
      <JobDescription
        @register="view = 'register'"
        @close="$emit('close')"
        :data="data"
      ></JobDescription>
    </div>
    <div v-if="view == 'register'">
      <JobForm @close="view = 'description'" :data="data"></JobForm>
    </div>
  </div>
</template>

<script>
import JobDescription from "./JobDescription.vue";
import JobForm from "./JobForm.vue";
export default {
  props: ["data"],
  components: {
    JobForm,
    JobDescription,
  },
  data() {
    return {
      view: "description",
    };
  },
  mounted() {},
  computed: {},
  methods: {
    getIdFromUrl(url) {
      if (url) {
        return url.match(/[-\w]{25,}/);
      } else {
        return "";
      }
    },
  },
};
</script>

<style lang="scss" scoped>
</style>